<template>
  <v-dialog
    v-model="isOpen"
    max-width="600"
    @input="handleClose"
  >
    <v-card>
      <v-card-title class="headline pb-10">
        <div class="columns">
          <div class="column">
            <h2 class="title is-3">Сделать копию коллекции</h2>
          </div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-layout row>
          <v-layout column>
            <b-field label="Название">
              <b-input v-model="newName"></b-input>
            </b-field>
          </v-layout>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn text
               color="primary"
               @click="cloneCollection()">Обновить</v-btn>
      </v-card-actions>
      <overlay-loader :show="isLoading"></overlay-loader>
    </v-card>
  </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader';
import { toFormData } from '@/app/shared/services/helpers';

export default {
  name: 'CollectionCopyModal',
  components: {
    OverlayLoader,
  },
  data() {
    return {
      newName: '',
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.newName = this.currentCollection.name + ' копия';
      }
    },
  },
  computed: {
    currentCollection: {
      get() {
        return this.$store.getters.CURRENT_COLLECTION;
      },
      set(value) {
        this.$store.commit('SET_CURRENT_COLLECTION', value);
      },
    },
    isLoading: {
      get() {
        return this.$store.getters.IS_COLLECTIONS_COPY_LOADING;
      },
      set(value) {
        this.$store.commit('SET_COLLECTIONS_COPY_LOADING', value);
      },
    },
    isOpen: {
      get() {
        return this.$store.getters.IS_CONFIRM_COLLECTIONS_COPY_MODAL;
      },
      set() {
        this.$store.commit('SET_CONFIRM_COLLECTIONS_COPY_MODAL', false);
      },
    },
    idFirebase() {
      return this.$route.params.idFirebase;
    }
  },
  methods: {
    handleClose(isOpen) {
      if (!isOpen) {
        this.close();
      }
    },
    cloneCollection() {
      let data = {
        collection_id: this.currentCollection.id,
        firebase: this.idFirebase,
        name: this.newName
      }
      this.$store.dispatch('CLONE_COLLECTION', data)
        .then(() => {
          this.$toast.success("Коллекция изменена!");
          this.$store.dispatch('GET_COLLECTIONS', {idFirebase: this.idFirebase});
          this.close();
        })
        .catch((error) => {
          if (error === 504) {
            this.$toast.error("Ошибка прокси");
          } else {
            this.$toast.error("Ошибка при изменении коллекции");
          }
        });
    },
    close() {
      this.currentCollection = {
        name: '',
        id: null,
        fields: [],
        use_standard_fields: false
      };
      this.isOpen = false;
      this.isLoading = false;
    },
  },
};
</script>

<style>
</style>
